// extracted by mini-css-extract-plugin
export default {"downloadBox":"style_downloadBox__HnOta"};